module.exports = __webpack_public_path__ + "img/box_pro_one_4.d37faf11.jpg";